export const ROUTE_PATHS = {
  login: '/login',
  /** Подтверждение email (staff/тренер/admin): вход только после подтверждения (auth-methods-uniform). */
  confirmEmail: '/confirm-email',
  /** Ключи совпадают с `routes_allowed` / `StaffSPARoutePaths` на бэкенде. */
  superadminDashboard: '/superadmin/dashboard',
  /** Учётные записи персонала платформы (отдельно от каталога сотрудников организации — экран `/users`). Legacy URL → редирект на `superadminUsersPlatform`. */
  superadminPlatformUsers: '/superadmin/platform-users',
  /** Глобальный каталог клиентов организаций (только СА). Legacy URL → редирект на `superadminUsersClients`. */
  superadminClientsCatalog: '/superadmin/clients-catalog',
  /** Хаб «Пользователи» в режиме платформы; ключ в capabilities — `/superadmin/users`. */
  superadminUsers: '/superadmin/users',
  /** Таб персонала платформы; ключ — `/superadmin/users/platform`. */
  superadminUsersPlatform: '/superadmin/users/platform',
  /** Таб глобального каталога клиентов; ключ — `/superadmin/users/clients`. */
  superadminUsersClients: '/superadmin/users/clients',
  /** Редактор платформенных ролей (JWT СА без контекста орг.); ключ — `/superadmin/users/roles`. */
  superadminUsersRoles: '/superadmin/users/roles',
  tenantDashboard: '/tenant/dashboard',
  fitnessDashboard: '/fitness/dashboard',
  /** Ключ `routes_allowed` `/fitness`: в UI ведёт на расписание (без query). */
  fitness: '/fitness',
  staffDashboard: '/staff/dashboard',
  /** Витрина UI на время доработки дизайна; не в списке staff-маршрутов бэкенда. */
  controls: '/controls',
  /** Витрина бейджей для Playwright-проверки контраста (только dev/e2e-сборка). */
  badgeContrastFixture: '/__e2e/badge-contrast',
  /**
   * Platform shell (СА без имперсонации). Гейт UI: `capabilities.staff_admin_shell.allowed` (нет отдельного ключа в `routes_allowed`).
   */
  superadmin: '/superadmin',
  /**
   * Список организаций платформы. Ключ capabilities — `/platform-organizations` (мост в `route-bridge.ts`).
   */
  superadminOrganizations: '/superadmin/organizations',
  /**
   * Заявки на подключение новых организаций (платформа). Ключ capabilities — `/platform-tenant-requests`
   * (мост в `route-bridge.ts`); детали — `/superadmin/tenant-requests/:requestId` (тот же capability-ключ).
   */
  superadminTenantRequests: '/superadmin/tenant-requests',
  superadminTenantRequestsDetailPattern: '/superadmin/tenant-requests/:requestId',
  /** Каталог тарифов платформы. Ключ capabilities — `/platform-plans`. */
  superadminPlans: '/superadmin/plans',
  /** Тариф и лимиты текущей организации; ключ в capabilities — `/tariffs` (см. `staff_spa_routes.go`). */
  tariffs: '/tariffs',
  /** Шаблон маршрута React: `/superadmin/organizations/:organizationId` (доступ — как у списка, `/platform-organizations`). */
  superadminOrganizationDetailPattern: '/superadmin/organizations/:organizationId',
  /**
   * Хаб «Пользователи» org (как `/superadmin/users`, но только тенант): ключ capabilities — `/users`.
   * Вкладки: `tenantUsersStaffTab` (`/all-users`), `tenantUsersClientsTab` (`/clients`), `tenantUsersAccessRbacTab` (`/access-rbac`).
   * Редиректы: `/all-users` → staff; `/clients` → clients; `/access-rbac` → `tenantUsersAccessRbacTab`.
   */
  staffDirectory: '/users',
  /** Таб «Персонал» в хабе `/users`; в `routes_allowed` — `/all-users`. */
  tenantUsersStaffTab: '/users/staff',
  /** Таб «Клиенты» в хабе `/users`; в `routes_allowed` — `/clients`. */
  tenantUsersClientsTab: '/users/clients',
  /** Таб «Специалисты» в хабе `/users`; в `routes_allowed` — `/staff`, модуль `fitness`. */
  tenantUsersTrainersTab: '/users/trainers',
  /** Таб «Роли и права» в хабе `/users`; в `routes_allowed` — `/access-rbac`, модуль `admin_rbac`. */
  tenantUsersAccessRbacTab: '/users/access-rbac',
  /** Роли и шаблоны прав org; ключ в capabilities — `/access-rbac`, модуль `admin_rbac`. Legacy URL → вкладка хаба. */
  accessRbac: '/access-rbac',
  /** Сводка организации (tenant); ключ в capabilities — `/organization`. */
  organization: '/organization',
  /**
   * Редактирование профиля орг.: тот же экран `/organization`, отдельный path для ЧПУ и nginx (без query).
   * Capability-ключ — `/organization` (см. `route-bridge.ts`).
   */
  organizationProfileEdit: '/organization/profile-edit',
  /**
   * Legacy URL: редирект на `/organization/profile-edit` (drawer профиля).
   * Ключ в capabilities по-прежнему `/organization/settings` (алиас доступа, не отдельный surface).
   */
  organizationSettings: '/organization/settings',
  /** Филиалы организации (tenant); ключ в capabilities — `/organization/branches`. */
  organizationBranches: '/organization/branches',
  /** Услуги организации (tenant); ключ в capabilities — `/organization/services`. */
  organizationServices: '/organization/services',
  /** Типы услуг (каталог core); ключ в capabilities — `/services-types`. */
  servicesTypes: '/services-types',
  /** Залы и пространства (каталог core); ключ в capabilities — `/services-spaces`. */
  servicesSpaces: '/services-spaces',
  /** Оборудование (tenant); ключ в capabilities — `/equipment`, модуль `equipment`. */
  equipment: '/equipment',
  /**
   * Каталог планов абонементов/сертификатов организации; ключ в capabilities — `/subscriptions` (не путать с `/subscription` — тариф орг.).
   */
  subscriptions: '/subscriptions',
  /** Список услуг каталога (core); ключ в capabilities — `/services-list`. */
  servicesList: '/services-list',
  /** Каноническая страница расписания; ключ capabilities — `/schedule` (ADR-0026). */
  schedule: '/schedule',
  /** Legacy URL расписания: сохраняем прямую ссылку, меню ведёт на `/schedule`. */
  scheduleTrainings: '/schedule-trainings',
  /** Рабочие часы тренеров; ключ в capabilities — `/schedule-workhours` (на бэкенде в паре с `schedule:staff_write`). */
  scheduleWorkhours: '/schedule-workhours',
  /** Справочник клиентов организации; ключ в capabilities — `/clients`. */
  clients: '/clients',
  /** Операционные платежи организации (реестр); ключ в capabilities — `/payments`. */
  payments: '/payments',
  /** Мои записи (брони текущего пользователя как клиента); ключ в capabilities — `/bookings`. */
  bookings: '/bookings',
  /** Записи клиентов (staff, все брони организации). */
  clientsBookings: '/clients-bookings',
  /** Подписка и тариф (read-only); ключ в capabilities — `/subscription`. */
  subscription: '/subscription',
  /** История счетов организации; ключ в capabilities — `/billing`. */
  billing: '/billing',
  /** Журнал аудита действий; ключ в capabilities — `/audit-log`. */
  auditLog: '/audit-log',
  /** Документация для staff (материалы `docs/release`); ключ в capabilities — `/docs`. */
  docs: '/docs',
  /** Профиль текущего пользователя (снимок `GET /auth/me`); ключ в capabilities — `/me`. */
  me: '/me',
  /** Оставить отзыв (форма обращения); ключ в capabilities — `/contact`. */
  contact: '/contact',
  /** Журнал обращений текущего пользователя; ключ в capabilities — `/feedback`. */
  feedback: '/feedback',
  /** Глобальные настройки виджета (MOBILE_DOMAIN); ключ в capabilities — `/global-widget-theme`, только СА без имперсонации орг. */
  globalWidgetTheme: '/global-widget-theme',
  /** Клиентский виджет и приложение (org + глобальное промо для СА без орг.); ключ — `/application`. */
  application: '/application',
  /** Публичное коммерческое предложение (тарифы без авторизации). */
  pricing: '/pricing',
  /** Публичная страница поддержки (Apple App Store support URL / контакты). */
  support: '/support',
  /** Публичная оферта платформы (App Store review / без авторизации). */
  publicOffer: '/public_offer',
  /** Пользовательское соглашение платформы (App Store review / без авторизации). */
  tos: '/tos',
  /** Политика конфиденциальности и обработки ПДн (App Store review / без авторизации). */
  gdpr: '/gdpr',
  /** Публичная анкета «Стать тенантом» (заявка на подключение) — без авторизации. */
  becomeTenant: '/become-tenant',
  /** Публичный портал заявки по magic-link (?token=…). Адрес = backend-письмо `TENANT_REQUEST_PUBLIC_BASE_URL` + path. */
  tenantRequestPortal: '/tenant-request',
  /** Виджет LAB — предпросмотр iframe/embed на MOBILE_DOMAIN; ключ — `/widget-embed-lab`, право `widget_embed_lab`. */
  widgetEmbedLab: '/widget-embed-lab',
  /** Воронка продаж; ключ `/sales-funnel`, модуль `sales_funnel` (`…/branches/{id}/sales-funnel/*`). */
  salesFunnel: '/sales-funnel',
  /** Настройки воронки; ключ `/sales-funnel-settings`, модуль `sales_funnel`. */
  salesFunnelSettings: '/sales-funnel-settings',
  /** Канонический путь каталога специалистов org; ключ `routes_allowed` — `/staff` (модуль `fitness`). */
  trainers: '/staff',
  /** Legacy URL: редирект на `/staff`. */
  trainersLegacy: '/trainers',
  /** Очередь подтверждений входа (org); ключ в capabilities — `/pending-auth`, модуль `automation` для не-СА платформы. */
  pendingAuth: '/pending-auth',
  /** Входящие заявки (`incoming_service_requests`); ключ — `/incoming-requests`, модуль `automation`, чтение `service_requests:org`. */
  incomingRequests: '/incoming-requests',
  /** Источники автоматизации филиала; ключ — `/automation-sources`, модуль `automation`. */
  automationSources: '/automation-sources',
  /** Входящие каналы автоматизации (IMAP, Telegram); ключ — `/automation-incoming`, модуль `automation`. */
  automationIncoming: '/automation-incoming',
  /** Проверка платёжных шлюзов (governance); ключ — `/payment-gateways`, право `payments:gateway_check`. */
  paymentGateways: '/payment-gateways',
  /** Аудит обращений к платёжным шлюзам (read-only); ключ — `/audit-payments`, право `audit:org_read` в org-context; СА без орг. — cross-org API. */
  auditPayments: '/audit-payments',
  /** API-токены организаций (платформа); ключ — `/admin-tokens`, только роль `superadmin` на бэкенде. */
  adminTokens: '/admin-tokens',
  /** YClients: сводка синхронизации (org); ключ — `/yc-sync-summary`, модуль `yclients`. */
  ycSyncSummary: '/yc-sync-summary',
  /** YClients: синхронизация по филиалу и ссылки на CRM; ключ — `/yc-sync-settings`. */
  ycSyncSettings: '/yc-sync-settings',
  /** YClients: мастер поиска компаний в кабинете партнёра и создания CRM-филиалов; ключ — `/yc-discover-branches`. */
  ycDiscoverBranches: '/yc-discover-branches',
  /** YClients: журнал событий (admin); ключ — `/yc-sync-log`. */
  ycSyncLog: '/yc-sync-log',
  /** YClients: конфликты и разрешение; ключ — `/yc-sync-conflicts`. */
  ycSyncConflicts: '/yc-sync-conflicts',
  /** YClients: очередь записей без сопоставления с CRM при импорте; ключ — `/yc-unmapped`. */
  ycUnmapped: '/yc-unmapped',
  /** Журнал проходов QR-доступа; ключ — `/qrcode`, модуль `qrcode`. */
  qrcode: '/qrcode',
  /** Настройки QR-доступа; ключ — `/qrcode-settings`, модуль `qrcode`. */
  qrcodeSettings: '/qrcode-settings',
  /** Канбан-трекер задач организации; ключ — `/tasks`, модуль `tasks`. */
  tasks: '/tasks',
  /** ИИ-помощник (текстовый чат) для администратора; ключ — `/assistant`. */
  assistant: '/assistant',
  /**
   * Глобальные настройки CRM (платформа) или реестр организации (юрлицо, SMS, соглашение) в контексте орг.
   * Ключ capabilities — `/settings` (см. `staff_spa_routes.go`, не путать с `/organization/settings`).
   */
  crmSettings: '/settings',
  superadminQRCodeConfig: '/superadmin/qrcode-config',
  superadminPayments: '/superadmin/payments',
  /** Отчёты ИИ-помощника и реестр промптов; ключ — `/superadmin/assistant`. */
  superadminAssistant: '/superadmin/assistant',
  forbidden: '/forbidden',
  moduleUnavailable: '/module-unavailable',
  bootstrapError: '/bootstrap-error',
  root: '/'
} as const;

/** Deep link: открыть drawer редактирования профиля орг. (только path, без `?`). */
export function pathOrganizationProfileEdit(): string {
  return ROUTE_PATHS.organizationProfileEdit;
}

/** ЧПУ карточки организации на платформе (суперадмин). */
export function pathSuperadminOrganizationDetail(organizationId: number): string {
  return `/superadmin/organizations/${organizationId}`;
}
